import React from "react";
const getFillColor = (color: string) => {
  return color === "currentColor" ? `` : `var(--color-${color})`;
};
const SvgRocketIcon = ({ title, theme = null, titleId = "", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 64"
    width="1em"
    height="1em"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g className="rocket_svg__nc-icon-wrapper">
      <path
        data-color="color-2"
        d="M29.81 9.5A22.359 22.359 0 0 0 5.669 20.051a1 1 0 0 0 .156 1.211l6.5 6.5A66.509 66.509 0 0 1 29.81 9.5ZM54.5 34.19a22.359 22.359 0 0 1-10.551 24.141 1 1 0 0 1-1.211-.156l-6.5-6.5A66.509 66.509 0 0 0 54.5 34.19ZM15.95 48.05a7.009 7.009 0 0 0-9.9 0C2.827 51.272 2.035 60.526 2 60.918A1 1 0 0 0 3 62h.082c.392-.032 9.646-.824 12.868-4.047a7.009 7.009 0 0 0 0-9.903Z"
      />
      <path d="M57.017 23.6A56.988 56.988 0 0 0 62 3.057a1 1 0 0 0-.289-.762A1.01 1.01 0 0 0 60.948 2a56.717 56.717 0 0 0-20.612 4.922ZM38.428 7.842c-19.73 9.875-27.534 28.652-27.634 28.9a1 1 0 0 0 .221 1.08l15.162 15.163a1 1 0 0 0 1.086.219c.247-.1 18.933-7.995 28.831-27.7ZM35 35a6 6 0 1 1 6-6 6 6 0 0 1-6 6Z" />
    </g>
  </svg>
);
export interface Props {
  color?: string;
  width?: string;
  height?: string;
  title: string;
  titleId?: string;
  theme?: any;
  fill?: string;
}
const SvgRocketStyle = ({
  color = "currentColor",
  title,
  fill,
  ...props
}: Props) => (
  <SvgRocketIcon
    color={getFillColor(color)}
    className={color === "currentColor" ? "icon-current-color" : ""}
    {...(color !== "currentColor"
      ? { style: { color: getFillColor(color), fill: getFillColor(color) } }
      : null)}
    fill={fill ?? getFillColor(color)}
    title={title}
    {...props}
  />
);
export const RocketIcon: any = SvgRocketStyle;
export default RocketIcon;
